module.exports = __webpack_public_path__ + "img/zlzx2.3140bd2c.png";